export const showVersion = {
  normal: 0, // 普通皮肤
  nOrder: 1, // n单皮肤
}
